/**
 * Common response structure for all BE API endpoints
 */
export interface ApiResponse<T> {
  flag: number
  message: string
  data: T
  next_page: number | null
}

/**
 * Generic response structure for BE API endpoints with a custom data field name.
 * Example usage: ApiResponseWithCustomDataField<"timings", Timing[]>
 * This will produce a type with { flag, message, timings, next_page }
 */
export type ApiResponseWithCustomDataField<K extends string, T> = {
  flag: number
  message: string
  next_page: number | null
} & {
  [key in K]: T
}

/**
 * Common NextPage structure used in responses with pagination
 */
export interface NextPage {
  offset: number
  limit: number
}

/**
 * Common type for coordinates
 */
export interface Coordinates {
  latitude: number
  longitude: number
}

/**
 * Common type for restaurant tier information
 */
export interface RestaurantTier {
  name: string
  logo: string
  background_image: string
}

/**
 * Common type for restaurant statuses
 */
export enum RestaurantStatus {
  Active = "active",
  Stop = "stop",
  Unknown = "",
}

/**
 * Common promo tag type used across various restaurant responses
 */
export interface PromoTag {
  type: PromoTagType
  tag: string
  icon: string
}

/**
 * Types of promo tags
 */
export enum PromoTagType {
  Delivery = "delivery",
  JointCampaign = "joint_campaign",
  Promo = "promo",
}

/**
 * Common structure for a campaign
 */
export interface Campaign {
  frame: string
  tag: string
}

/**
 * Common BE Points campaign structure
 */
export interface BePointCampaign {
  tag: string
}

export interface Collection {
  id: number
  name: string
  description: string
  flow_type: string
  collection_layout: string
  collection_type: string
  show_view_all: boolean
  icon: string
  web_image: string
  image_compressed: string
  web_image_compressed: string
  deep_link: string
  banner_image: string
  detail_description: string
}

/**
 * Restaurant timing
 */

export interface RestaurantTimings {
  day_id: number
  name: string
  timings: Timing[]
}

export interface Timing {
  time_id: number
  start_time: string
  end_time: string
  category_list: unknown[]
  item_list: unknown[]
}
